import { useNodeName } from '@/context/names/names-context';
import { useReferenceMap } from '@/context/references/references-context';
import { resolveRefTokens } from '@/lib/resolve-ref-tokens';
import { sanitizeBlockHtml } from '@/lib/sanitize';
import { styleRuleToLeafCssVars, useStyleRule } from '@/lib/style-profile';
import type { DocumentEntity } from '@/context/store/slices/documentDataSlice';

import './document-view-text.scss';

type Props = {
  node: DocumentEntity & { type: 'text' };
  depth?: number;
};

function DocumentViewText({ node, depth = 0 }: Props) {
  const refMap = useReferenceMap();
  const name = useNodeName(node.id);
  const rule = useStyleRule(node.style, depth);
  const html = sanitizeBlockHtml(
    resolveRefTokens(node.text ?? '', refMap, node.id),
  );

  const styleVars = styleRuleToLeafCssVars(rule);

  return (
    <div
      id={node.id}
      data-type="card"
      className={`doc-view-text is-${node.style}`}
      style={styleVars}
    >
      {name && <h3 className="doc-view-text__name">{name}</h3>}
      <span
        className="doc-view-text__content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}

export { DocumentViewText };
